import { createSlice } from '@reduxjs/toolkit';


interface IProps  {
    modalIsOpen: boolean;
}

export const MobileMenuModalStateSlice = createSlice({
    name: 'mobileMenuOpen',
    initialState: {
        modalIsOpen: false,
    },
    reducers: {
        toggle: (state, action) => {
            state.modalIsOpen = action.payload;
        }
    }
    // extraReducers: {}
});

export default MobileMenuModalStateSlice
export const MobileMenuStateAction = MobileMenuModalStateSlice.actions
export const MobileMenuModalSelector = (store: { mobileMenuOpen: IProps }): IProps => store.mobileMenuOpen;
import { createSlice } from '@reduxjs/toolkit';


interface IProps  {
    modalIsOpen: boolean;
}

export const MobileMenuModalStateSlice = createSlice({
    name: 'mobileMenuOpen',
    initialState: {
        modalIsOpen: false,
    },
    reducers: {
        toggle: (state, action) => {
            state.modalIsOpen = action.payload;
        }
    }
    // extraReducers: {}
});

export default MobileMenuModalStateSlice
export const MobileMenuStateAction = MobileMenuModalStateSlice.actions
export const MobileMenuModalSelector = (store: { mobileMenuOpen: IProps }): IProps => store.mobileMenuOpen;
